export enum LayerControlEnum {
  SHOW_VMS = 'showVMS',
  SHOW_RADARS = 'showRadars',
  SHOW_TRAFFIC = 'showTraffic',
  SHOW_EVENTS = 'showEvents',
  SHOW_PARKINGS = 'showParkings',
  SHOW_PARKING_SPOTS = 'showParkingSpots',
  SHOW_PARKING_BOARDS = 'showParkingBoards',
  SHOW_BIKE_STATIONS = 'showBikeStations',
  SHOW_SCATS = 'showSCATS',
  SHOW_CAM = 'showCam',
  SHOW_WEATHER_STATIONS = 'showWeatherStations',
  SHOW_PARKING_ZONES = 'showParkingZones',
  SHOW_PARKING_METERS = 'showParkingMeters',
  SHOW_PARKING_GROUPS = 'showParkingGroups',
  SHOW_CCTV_FIXED_CAMERAS = 'showCctvFixedCameras',
  SHOW_CCTV_PTZ_CAMERAS = 'showCctvPtzCameras',
  SHOW_TRACKS = 'showTracks'
}